import { render, staticRenderFns } from "./SchemaSearchSelect.vue?vue&type=template&id=65f63253&scoped=true&"
import script from "./SchemaSearchSelect.vue?vue&type=script&lang=js&"
export * from "./SchemaSearchSelect.vue?vue&type=script&lang=js&"
import style0 from "./SchemaSearchSelect.vue?vue&type=style&index=0&id=65f63253&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f63253",
  null
  
)

export default component.exports